import {
  apiRequest,
  daftarpegawai,
  addpegawaitolist,
  daftarpangkat,
  detailpegawai,
  PromotionPeriodDetail,
  ListPresensi,
  CancelPresensi,
  GeneratePresensi,
  UpdateJabatan,
  ListJabatan,
} from "../../../../../services/adapters/kepegawaian/revisikeuanganService";

import {
  detailEmployee,
  updateGrade,
  updateSkp,
  updatePenilaian,
  recalculationRevision,
  gradeList,
  individualcriterialist,
  listComponent,
  listPenilaianBefore,
  listCriteria,
} from "../../../../../services/adapters/kepegawaian/revisiTunjanganKhususService";

class CreateRepository {
  fetchdetailPegawaiChannel = async (query) => {
    return await apiRequest(
      "get",
      detailEmployee,
      {
        params: query,
      },
      true
    );
  };

  updateGrade = async (query) => {
    return await apiRequest(
      "post",
      updateGrade,
      {
        body: query,
      },
      true
    );
  };
  updateSkp = async (query) => {
    return await apiRequest(
      "post",
      updateSkp,
      {
        body: query,
      },
      true
    );
  };
  updatePenilaian = async (query) => {
    return await apiRequest(
      "post",
      updatePenilaian,
      {
        body: query,
      },
      true
    );
  };

  recalculationRevision = async (query) => {
    return await apiRequest(
      "post",
      recalculationRevision,
      {
        body: query,
      },
      true
    );
  };

  fetchGrade = async (query) => {
    return await apiRequest(
      "get",
      gradeList,
      {
        params: query,
      },
      true
    );
  };

  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      addpegawaitolist,
      {
        body: query,
      },
      true
    );
  };

  fetchEmployee = async (query) => {
    return await apiRequest(
      "get",
      daftarpegawai,
      {
        params: query,
      },
      true
    );
  };
  fetchRank = async (query) => {
    return await apiRequest(
      "get",
      daftarpangkat,
      {
        params: query,
      },
      true
    );
  };

  fetchDetail = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      PromotionPeriodDetail,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchListPresensi = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      ListPresensi,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchDeletePresensi = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      CancelPresensi,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchGeneratePresensi = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      GeneratePresensi,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };
  fetchUpdateJabatan = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      UpdateJabatan,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };
  fetchListJabatan = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      ListJabatan,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };
  fetchIndividualCriteria = async (query) => {
    return await apiRequest("get", individualcriterialist, {
      params: query
    }, true)
  }

  fetchComponent = async (query) => {
    return await apiRequest(
      "get",
      listComponent,
      {
        params: query,
      },
      true
    );
  };
  fetchComponentHistory = async (query) => {
    return await apiRequest(
      "get",
      listPenilaianBefore,
      {
        params: query,
      },
      true
    );
  };

  fetchCriteria = async (query) => {
    return await apiRequest(
      "get",
      listCriteria,
      {
        params: query,
      },
      true
    );
  };
}

export default CreateRepository;
